export default "./images/survio-7rh9G-assets-image_choice.png";